import type { PageId } from "./pageIds";

/**
 * "Reader + AI" is Reader with Nira Chat access: the same pages as Reader,
 * plus the nira page that Reader is excluded from.
 *
 * Mirrored in fn-nira-backend src/validators/pagePermissions.validators.ts —
 * a contract test in each repo fails if the two tables diverge.
 */
export const DEFAULT_PAGE_PERMISSIONS: Record<PageId, string[]> = {
  main: ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
  "executive-dashboard": ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
  "threat-map": ["Super Admin", "CSE", "CxO", "Reader", "Reader + AI"],
  "posture-management": ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
  nira: ["Super Admin", "CSM", "CSE", "CxO", "Reader + AI"],
  "client-hub": ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
  "client-hub/overview": ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
  "client-hub/product-maturity": ["Super Admin", "CSM", "CSE", "CxO"],
  "client-hub/roi-insights": ["Super Admin", "CSM", "CSE", "CxO"],
  "client-hub/qbr-planning": ["Super Admin", "CSM", "CSE", "CxO"],
  "governance/ai-inventory": ["Super Admin", "CSE", "CxO", "Reader", "Reader + AI"],
  "governance/ai-adoption": ["Super Admin", "CSE", "CxO", "Reader", "Reader + AI"],
  "governance/data-risks": ["Super Admin", "CSE", "CxO", "Reader", "Reader + AI"],
  "governance/tprm": ["Super Admin", "CSE", "CxO", "Reader", "Reader + AI"],
  profile: ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
  help: ["Super Admin", "CSM", "CSE", "CxO", "Reader", "Reader + AI"],
};

/** All roles the system recognizes */
export const ALL_ROLES = [
  "Super Admin",
  "CSM",
  "CSE",
  "CxO",
  "Reader",
  "Reader + AI",
] as const;

/** Roles shown in the Access Control settings UI (Super Admin excluded -- always has access) */
export const CONFIGURABLE_ROLES = ["CSM", "CSE", "CxO", "Reader", "Reader + AI"] as const;
